import { render, staticRenderFns } from "./UserActivities.vue?vue&type=template&id=305b4e33&scoped=true"
import script from "./UserActivities.vue?vue&type=script&lang=js"
export * from "./UserActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305b4e33",
  null
  
)

export default component.exports